import React from 'react';
import styles from '../index.module.scss';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import classNames from 'classnames';
import { GENDER_OPTIONS } from '../../../../hooks/intake-options';

const GenderField = ({ required = true }: { required?: boolean }) => {
  const { control } = useFormContext();

  return (
    <FormControl required={required}>
      <Controller
        control={control}
        name="gender"
        rules={{
          required: required && 'Please enter assigned sex at birth',
        }}
        render={({ field }) => {
          return (
            <RadioGroup
              data-name="gender-radio-group"
              value={field.value}
              className={classNames(styles.radioFieldWrapper, 'flex flex-col')}
            >
              <FormLabel className={styles.formLabel}>Sex</FormLabel>
              <div className={styles.radioLabelsWrapper}>
                {GENDER_OPTIONS?.map(({ value, label }) => (
                  <FormControlLabel
                    key={value}
                    className={styles.radioLabel}
                    control={
                      <Radio
                        data-testid={`gender-${label}`}
                        value={value}
                        onChange={field.onChange}
                        classes={{
                          root: styles.radio,
                          checked: styles.checked,
                        }}
                      />
                    }
                    label={label}
                  />
                ))}
              </div>
            </RadioGroup>
          );
        }}
      />
    </FormControl>
  );
};

export default GenderField;
